// src/pages/PesquisaJurisprudencia/utils/constants.js

export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:5000/api';

export const TRIBUNAIS_DISPONVEIS = [
  { value: 'STJ',  label: 'STJ  - Supremo Tribunal de Justiça' },
  { value: 'TRL',  label: 'TRL  - Tribunal da Relação de Lisboa' },
  { value: 'TRP',  label: 'TRP  - Tribunal da Relação do Porto' },
  { value: 'TRC',  label: 'TRC  - Tribunal da Relação de Coimbra' },
  { value: 'TRE',  label: 'TRE  - Tribunal da Relação de Évora' },
  { value: 'TRG',  label: 'TRG  - Tribunal da Relação de Guimarães' },
  { value: 'TJUE', label: 'TJUE - Tribunal de Justiça da União Européia' },
  { value: 'STA',  label: 'STA  - Supremo Tribunal Administrativo' },
  { value: 'TCAS', label: 'TCAS - Tribunal Central Administrativo Sul' },
  { value: 'TCAN', label: 'TCAN - Tribunal Central Administrativo Norte' }
];

export const PAGINACAO_INICIAL = {
  current_page: 1,
  total_pages: 0,
  total_records: 0,
  limit: 20
};